import type { CrudFilter } from "@refinedev/core";

export type AuditFiltersState = {
  actor_id: string;
  action: string;
  dateFrom: string;
  dateTo: string;
};

export const EMPTY_AUDIT_FILTERS: AuditFiltersState = {
  actor_id: "",
  action: "",
  dateFrom: "",
  dateTo: "",
};

export function buildAuditRefineFilters(f: AuditFiltersState): CrudFilter[] {
  const result: CrudFilter[] = [];
  if (f.actor_id) {
    result.push({ field: "actor_id", operator: "eq", value: f.actor_id });
  }
  if (f.action) {
    result.push({ field: "action", operator: "eq", value: f.action });
  }
  if (f.dateFrom) {
    result.push({ field: "dateFrom", operator: "gte", value: f.dateFrom });
  }
  if (f.dateTo) {
    result.push({ field: "dateTo", operator: "lte", value: f.dateTo });
  }
  return result;
}
